import {v4 as uuidv4} from "uuid";

export const getUuid = () => {
    return uuidv4();
}